<template>
  <div id="verify-token"></div>
</template>
<script>
import ServerResponse from "@/store/ServerResponse";

export default {
  name: "VerifyPasswordReset",
  methods: {
    verify() {
      this.$store
        .dispatch("auth/verifyResetPassword", { passwordResetToken: this.$route.query.token })
        .then(token => {
          this.$router.push({ name: "change-password", params: { token } });
        })
        .catch((error) => {
          this.$router.push({
            name: "error",
            params: { serverResponse: new ServerResponse(error.response.data)}
          });
        });
    }
  },
  mounted() {
    this.verify();
  }
};
</script>
